import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AnnualReportProvider } from '@modeso/aumico-lib-annualreport-fe';
import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { Observable, filter, first, map } from 'rxjs';
import { Paths } from '../../../enums/paths.enum';

/**
 * Keeps the FX tab off reports that are not Functional Currency ones. Hiding the tab link is not
 * enough on its own — the URL is reachable directly and from a bookmark.
 */
@Injectable({
    providedIn: 'root',
})
export class FxGuard implements CanActivate {
    constructor(private router: Router, private annualReportsProvider: AnnualReportProvider) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.annualReportsProvider.getActiveAnnualReport$().pipe(
            filter((activeAnnualReport) => activeAnnualReport != null),
            first(),
            map((activeAnnualReport: IAnnualReport) => {
                if (activeAnnualReport.setupData?.fxEnabled === true) {
                    return true;
                }

                const parentUrl = state.url.slice(0, state.url.indexOf(route.url[route.url.length - 1].path));

                return this.router.parseUrl(parentUrl + Paths.MAPPING);
            }),
        );
    }
}
